<div *ngIf="options != null" [@openSnackbar]="animationState">
  <p> {{ options?.message }} | <a (click)="clicked()">{{ options?.action?.label || 'Close' }}</a></p>
</div>